export default __webpack_public_path__ + "b1104bcd7672f5af09ff016d3746b469.jpg";